<template>
  <div class="hjqy">
    <headerBanner :bannerUrl='bannerUrl'></headerBanner>
    <div class="common_title clearfix">
      <div class="icon"><i class="icons i7"></i></div><p>历届获奖企业<span>（排名不分先后）</span></p>
    </div>

    <div class="ljhjqy_detail clearfix">
      <div class="ljhjqy_detail_year EY_Regular">
        {{year}}
      </div>
      <div class="ljhjqy_detail_list clearfix">
        <div class="ljhjqy_detail_item clearfix" v-for='item in data'>
          <router-link :to="'/ljhjqy/detail/'+item.id">
            <div class="img_wrap">
              <img :src="domain+item.litpic" alt="">
            </div>
            <div class="ljhjqy_detail_item_text">
              <p class="company">{{item.copyfrom}}</p>
              <p class="hy">{{item.author}}</p>
              <p class="name">{{item.title}}</p>
              <p class="zw">{{item.shorttitle}}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerBanner from '@/components/public/header'
export default {
  name: 'ljhjqy',
  data () {
    return {
      data: '',
      domain:'https://eympe.vapps.me',
      year:'',
      bannerUrl:''
    }
  },
  components:{
    headerBanner:headerBanner
  },
  mounted:function(){
     this.$http.post('https://eympe.vapps.me/index.php?g=Index&m=Index&a=get_lists',
       {
          cid:this.$route.params.id
        },
       {emulateJSON : true})
   .then((response) => {
         this.data=response.body.data
         this.bannerUrl = this.domain+response.body.bgpic
         console.log(response)
         this.year=this.data[0].catename
     })
  }
}
</script>

<style scoped>
  i.i7{
    width: 0.41rem;
    height: 0.24rem;
    background-position: -0.63rem -2.09rem;
  }
  .ljhjqy_detail{
    padding: 0 0.24rem 0 0.38rem;
  }
  .ljhjqy_detail_year{
    font-size: 0.25rem;
    color: #000000;
    margin-bottom: 0.2rem;
  }
  .ljhjqy_detail_item{
    float: left;
    width: 50%;
    height: 1.07rem;
    overflow: hidden;
    margin-bottom: 0.2rem;
  }
  .ljhjqy_detail_item .img_wrap{
    width: 0.93rem;
    float: left;
    overflow: hidden;
  }
  .ljhjqy_detail_item .img_wrap img{
    width: 100%;
  }
  .ljhjqy_detail_item_text{
    width: 1.67rem;
    float: left;
    margin-left: 0.1rem;
    font-size: 0.13rem;
    color: #000;
  }
  .ljhjqy_detail_item_text .hy{
    color: #6d6e71;
    padding-bottom: 0.04rem;
    border-bottom: 1px solid #828282;
    margin-bottom: 0.04rem;
  }
  .ljhjqy_detail_item_text .name{
    font-weight: bold;
  }
  .ljhjqy_detail_item_text p{
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
</style>


// WEBPACK FOOTER //
// src/components/ljhjqy_detail.vue